import React from "react";

const SVG = ({
  style = {},
  fill = "#000",
  className = "",
  width="16.637", 
  height="16.637", 
  viewBox="0 0 16.637 16.637"
}) => (
    <svg
      width={width}
      style={style}
      height={width}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
      className={`svg-icon ${className || ""}`}
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g id="Group_2" data-name="Group 2" transform="translate(-57.451 893.907)">
        <path fill={fill} id="Path_341" d="M73.87-892.878l-.046-.766-.766-.046a122.084 122.084 0 0 0-14.579 0l-.766.046-.046.766a122.153 122.153 0 0 0 0 14.579l.046.766.766.046a121.9 121.9 0 0 0 14.578 0l.766-.046.046-.766a122.158 122.158 0 0 0 .001-14.579zm-1.684 13.707a120.46 120.46 0 0 1-12.835 0 120.517 120.517 0 0 1 0-12.835 120.524 120.524 0 0 1 12.835 0 120.507 120.507 0 0 1 .001 12.835z" className="cls-1" data-name="Path 341" />
        <path fill={fill} id="Rectangle_21" d="M0 0h6.708v1.73H0z" className="cls-1" data-name="Rectangle 21" transform="translate(64.4 -890.078)" />
        <path fill={fill} id="Rectangle_22" d="M0 0h10.426v1.73H0z" className="cls-1" data-name="Rectangle 22" transform="translate(60.681 -886.454)" />
        <path fill={fill} id="Rectangle_23" d="M0 0h10.676v1.73H0z" className="cls-1" data-name="Rectangle 23" transform="translate(60.431 -882.829)" />
        <circle fill={fill} id="Ellipse_1" cx="1.604" cy="1.604" r="1.604" className="cls-1" data-name="Ellipse 1" transform="translate(60.41 -890.98)" />
      </g>
    </svg>
  );

export default SVG;



// WEBPACK FOOTER //
// ./src/components/UI/Icons/Other.js